import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate
} from '@azure/msal-react';
import { IconMoonStars, IconSun } from '@tabler/icons-react';

import {
    ActionIcon,
    Flex,
    Text,
    useComputedColorScheme,
    useMantineColorScheme
} from '@mantine/core';

import { DocumentDto } from '../../api/models';
import { LogInButton } from '../auth/LogInButton.tsx';
import { LogOutButton } from '../auth/LogOutButton.tsx';
import { LogoTitleBarComponent } from './LogoTitleBarComponent.tsx';

interface SelectedDocumentInfo {
    document: DocumentDto;
    projectName: string;
}

interface HeaderProps {
    selectedDocumentInfo?: SelectedDocumentInfo;
    isNavbarOpen: boolean;
}

const Header = ({ selectedDocumentInfo, isNavbarOpen }: HeaderProps) => {
    const { toggleColorScheme } = useMantineColorScheme();
    const computedColorScheme = useComputedColorScheme('dark');
    const dark = computedColorScheme === 'dark';

    return (
        <Flex justify={'space-between'} align={'center'}>
            <Flex align={'center'} gap={'md'}>
                <LogoTitleBarComponent />
                {!isNavbarOpen && selectedDocumentInfo && (
                    <Text size='sm' c='dimmed' style={{ fontWeight: 500 }}>
                        {selectedDocumentInfo.projectName} /{' '}
                        {selectedDocumentInfo.document.name}
                    </Text>
                )}
            </Flex>

            <Flex gap={6} align="center">
                <ActionIcon
                    variant='subtle'
                    size={'lg'}
                    color='gray'
                    onClick={() => toggleColorScheme()}
                    title='Toggle color scheme'
                >
                    {dark ? (
                        <IconSun size='1rem' />
                    ) : (
                        <IconMoonStars size='1rem' />
                    )}
                </ActionIcon>

                <AuthenticatedTemplate>
                    <LogOutButton />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <LogInButton />
                </UnauthenticatedTemplate>
            </Flex>
        </Flex>
    );
};

export default Header;
